import axios, { AxiosInstance } from "axios";

const BASE_URL = process.env.REACT_APP_SERVER_URL;
const BASE_FILE_SERVER_URL = process.env.REACT_APP_FILE_SERVER_URL;

axios.defaults.baseURL = BASE_URL;

const baseApi: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const baseFileApi: AxiosInstance = axios.create({
  baseURL: BASE_FILE_SERVER_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

baseApi.interceptors.request.use(
  config => {
    // 요청이 전달되기 전에 작업 수행
    const accesstoken = localStorage.getItem("mdstech_accessToken");
    // const refreshtoken = localStorage.getItem("refreshtoken");
    if (accesstoken !== "undefined") {
      config.headers.Authorization = accesstoken ? `Bearer ${accesstoken}` : null;
    }
    return config;
  },
  error => {
    // 요청 오류가 있는 작업 수행
    return Promise.reject(error);
  }
);
baseApi.interceptors.response.use(
  async response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export { baseApi, baseFileApi };
